export default __webpack_public_path__ + "static/media/Calendar.35ada6fa.svg";